export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-medium rounded-full mb-4">
              移动端专属体验
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              飞飞漫画 APP · 口袋里的漫画馆
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              专为移动端优化的下拉式阅读引擎，离线缓存随时随地畅读。支持护眼模式、智能书签同步，追更提醒不错过任何更新。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              {[
                { icon: 'ri-smartphone-line', label: 'iOS 版' },
                { icon: 'ri-android-line', label: 'Android 版' },
                { icon: 'ri-computer-line', label: '网页版' },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-2 px-5 py-2.5 bg-background-100 rounded-lg border border-background-200/70 cursor-pointer hover:border-primary-300 hover:bg-primary-50/50 transition-all"
                >
                  <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className={item.icon}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[340px] aspect-[3/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20colorful%20comic%20reading%20app%20interface%20with%20manga%20panels%20and%20Japanese%20style%20artwork%2C%20clean%20flat%20design%2C%20warm%20orange%20and%20cream%20background%2C%20minimal%20UI%2C%20isometric%20perspective%2C%20soft%20lighting&width=680&height=1134&seq=app-comic-2026&orientation=portrait"
                alt="飞飞漫画 APP 移动端阅读界面展示"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}